import React from 'react';
import { useTranslation } from 'react-i18next';

function NewListing() {
  const { t } = useTranslation('common');

  return (
    <div className="common-listing-card card">
      <div className="card-header">
        <ul className="card-header-icon">
          <li>
            <div className="common-checkbox size-sm">
              <input type="checkbox" id="check2221" name="demo 1" value="demo 1" />
              <label htmlFor="check2221" className="chklabel">
                <span className="sr-only">{t('CHECK_BOX_LABEL.I AGREE')}</span>
              </label>
            </div>
          </li>
          <li>
            <a href={false} title={t('LISTING_CARD.EDIT')}>
              <i className="icon-Library-1" />
            </a>
          </li>

          <li>
            <a href={false} title={t('LISTING_CARD.EDIT')}>
              <i className="icon-Usage" />
            </a>
          </li>
          <li>
            <a href={false} title={t('LISTING_CARD.DELETE')}>
              <i className="icon-multi-costing" />
            </a>
          </li>
          <li>
            <a href={false} title={t('LISTING_CARD.EDIT')}>
              <i className="icon-Usage" />
            </a>
          </li>
          <li>
            <a href={false} title={t('LISTING_CARD.DELETE')}>
              <i className="icon-Product-Group" />
            </a>
          </li>
          <li>
            <a href={false} title={t('LISTING_CARD.DELETE')}>
              <i className="icon-More" />
            </a>
          </li>
        </ul>
      </div>
      <div className="card-body">
        <h4 className="title link-title">MM-CH-Tweed</h4>
        <ul className="card-ul">
          <li>
            <strong>Type: </strong>
            Natural
          </li>
          <li>
            <strong>Description: </strong>
            Tweed
          </li>
          <li>
            <strong>Supplier: </strong>
            Martin Mills
          </li>
          <li>
            <strong>Placement: </strong>
            Shell
          </li>
          <li>
            <strong>Composition: </strong> 100% Wool
          </li>
          <li>
            <strong>Weight: </strong> 310 GSM
          </li>
          <li>
            <strong>Size/Volume: </strong> 55 (Cutting Width) Inch(es)
          </li>
          <li>
            <strong>Quantity: </strong> 2.14 (avg. Per Unit) Metres
          </li>
          <li>
            <strong>Additional Info: </strong> Number of Needles 132, Forming: SPA..
          </li>
        </ul>
        <div className="status status-green" />
      </div>
    </div>
  );
}

export default NewListing;
